import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"upload\"><path d=\"M25.32 11.38a6.61 6.61 0 11-.1 13.22H18.5v-5h3.37l-5.07-5-5.06 5h3.38v5H3.28a3.28 3.28 0 01-.66-6.5v-.74A4.66 4.66 0 017 12.72a8.06 8.06 0 0115-.52 7.32 7.32 0 013.31-.81z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/upload.svg
// module id = OWkb
// module chunks = 1